import React from 'react';
import classnames from 'classnames';
import DeviationDumbView from '../../../../Dumbo';
import DeviationThumbOverlayDefault from '../../../legos/DeviationThumbOverlayDefault';
import DeviationThumbMiddleContent from '../../../legos/DeviationThumbMiddleContent';
import ThumbOverlayBackground from '../../../legos/ThumbOverlayBackground';
import ThumbLink from '../../../legos/ThumbLink';
import s from './MobileThumbContent.scss';
const MobileThumbContent = ({ deviation , width , height , responsive , className  })=>{
    return /*#__PURE__*/ React.createElement(ThumbLink, {
        deviation: deviation,
        width: width,
        height: height,
        wrapperClassName: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement(DeviationDumbView, {
        deviation: deviation,
        width: width,
        height: height,
        responsive: responsive,
        // We'll rely on the link to inform screen readers
        "aria-hidden": "true"
    }), /*#__PURE__*/ React.createElement(ThumbOverlayBackground, {
        deviation: deviation,
        className: s['underlay'],
        showDefaultHover: true
    }), /*#__PURE__*/ React.createElement(DeviationThumbOverlayDefault, {
        deviation: deviation,
        width: width,
        height: height,
        className: s['cover']
    }), /*#__PURE__*/ React.createElement(DeviationThumbMiddleContent, {
        deviation: deviation,
        thumbWidth: width,
        thumbHeight: height,
        className: s['middle']
    }));
};
MobileThumbContent.displayName = 'MobileThumbContent';
export default MobileThumbContent;
